import { roleService } from '../../helpers/services/role.service'
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'

export const state = {
  list: {
    data: [],
    pagination: { pageNumber: 0, pageSize: 0, lastPage: 0, tableRowsCount: 0 },
  },
  details: {},
  status: { list: true, detail: true, save: true },
}

export const ROLE_MODULE = 'role'

export const GET_ALL_ROLES = 'getAllRoles'
export const GET_ROLE = 'getRole'
export const CREATE_ROLE = 'createRole'
export const UPDATE_ROLE = 'updateRole'
export const UPDATE_ROLE_STATUS = 'updateRoleStatus'

const REQUESTING = 'requesting'
const ALL_ROLES_SUCCESS = 'allRolesSuccess'
const GET_ROLE_SUCCESS = 'getRoleSuccess'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'

function mapRoleRow(item) {
  return {
    id: item.uuid,
    name: item.name,
    isActive: item.is_active,
    permissions: (item.permissions || []).map((p) => p.code || p.name),
    createdAt: filtersHelper.getDateFormat(item.created_at),
    updatedAt: filtersHelper.getDateFormat(item.updated_at),
  }
}

export const actions = {
  [GET_ALL_ROLES]({ commit }, { filter }) {
    commit(REQUESTING, 'list')
    roleService
      .getAllRoles(filter)
      .then((result) => {
        commit(ALL_ROLES_SUCCESS, { data: result })
        commit(SUCCESS)
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
  [GET_ROLE]({ commit }, { id }) {
    commit(REQUESTING, 'detail')
    return roleService
      .getRole(id)
      .then((result) => {
        commit(GET_ROLE_SUCCESS, result)
        commit(SUCCESS)
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
  [CREATE_ROLE]({ commit, dispatch }, { data, filter }) {
    commit(REQUESTING, 'save')
    return roleService
      .createRole(data)
      .then((result) => {
        sharedHelper.alertSuccessMessage(i18n.t('label.createX', [i18n.t('module.role')]))
        commit(SUCCESS)
        dispatch(GET_ALL_ROLES, { filter })
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
  [UPDATE_ROLE]({ commit, dispatch }, { id, data, filter }) {
    commit(REQUESTING, 'save')
    return roleService
      .updateRole(id, data)
      .then((result) => {
        sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('module.role')]))
        commit(SUCCESS)
        dispatch(GET_ALL_ROLES, { filter })
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
  [UPDATE_ROLE_STATUS]({ commit, dispatch }, { id, isActive, filter }) {
    commit(REQUESTING, 'save')
    return roleService
      .updateRoleStatus(id, isActive)
      .then((result) => {
        sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('label.status')]))
        commit(SUCCESS)
        dispatch(GET_ALL_ROLES, { filter })
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
}

export const mutations = {
  [ALL_ROLES_SUCCESS](state, { data }) {
    const roles = data.data || []
    state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)
    state.list.data = data.success ? roles.map(mapRoleRow) : roles
  },
  [GET_ROLE_SUCCESS](state, data) {
    state.details = mapRoleRow(data.data || {})
  },
  [FAILURE](state) {
    state.status = { list: true, detail: true, save: true }
  },
  [REQUESTING](state, type) {
    state.status[type] = false
  },
  [SUCCESS](state) {
    state.status = { list: true, detail: true, save: true }
  },
}
